<div class="district-dashboard">
  <!-- Slot for report filter -->
  <!-- To use: <div report-filter>{{ filter content }}</div> -->
  <ng-content select="[report-filter]"></ng-content>

  <div class="dashboard-toolbar">
    <button class="tourPageBtn" id="help-tour-btn" title="Tour This Page" (click)="onTourClicked()">
      <img src="/assets/images/tutorialOverlayBttn.svg" />
    </button>
    <button id="printButton" class="btn print-summary-button" (click)="onPrintClicked()"><fa-icon [icon]="printIcon"></fa-icon> Print</button>
  </div>

  <div class="dashboard-header-bar">{{ reportTitle() }}</div>

  <div *ngIf="loadError()" class="alert message alert-danger">{{ loadError() }}</div>

  <!-- Report body -->
  <ng-content></ng-content>
</div>
